(function () {
  try {
    var tried = 0;

    function debug() {
      if (window && window.console && typeof window.console.log === 'function') {
        window.console.log.apply(window.console, arguments);
      }
    }

    //debug('[judgeme-viewmore] script loaded');

  function findReviewBody(item) {
    var candidates = [
      '.jdgm-carousel-item__review-body',
      '.jdgm-review-body',
      '.jdgm-review__body',
      '.jdgm-review-body__content',
      '.jdgm-carousel-item__review-content',
      '.jdgm-review-content',
      '.jdgm-carousel-item__body'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var sel = candidates[i];
      var el = item.querySelector(sel);
      if (el) return el;
    }

    return item.querySelector('p');
  }

  function findAppendTarget(item) {
    var candidates = [
      '.jdgm-carousel-item__review-content-wrapper',
      '.jdgm-carousel-item__body',
      '.jdgm-carousel-item__content',
      '.jdgm-carousel-item__body-wrapper'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = item.querySelector(candidates[i]);
      if (el) return el;
    }
    return item;
  }

  function processItem(item) {
    if (!item || item.dataset.jvProcessed) return;
    //debug('[judgeme-viewmore] processing item', item);

    var body = findReviewBody(item);
    if (!body) {
      //debug('[judgeme-viewmore] no review-body found for item');
      return;
    }
    var p = body.querySelector('p') || body;
    if (!p) {
      //debug('[judgeme-viewmore] no paragraph found inside review-body');
      return;
    }

    // Split titles like "Product: ... Header: ...
    try {
      var titleSelectors = [
        '.jdgm-carousel-item__review-title',
      ];
      titleSelectors.forEach(function (sel) {
        var titles = item.querySelectorAll(sel);
        titles.forEach(function (t) {
          if (!t || t.dataset.jvTitleProcessed) return;
          var text = (t.textContent || '').trim();
          if (!text) return;
          var lower = text.toLowerCase();
          var marker = 'header:';
          var idx = lower.indexOf(marker);
          if (idx > -1) {
            var left = text.slice(0, idx).trim();
            var newText = left;
            if (!newText) {
              // fallback: remove marker and everything after (case-insensitive)
              try {
                newText = text.replace(new RegExp(marker + '.*$', 'i'), '').trim() || text;
              } catch (re) {
                newText = left || text;
              }
            }
            // apply safely using textContent to avoid injecting HTML
            t.textContent = newText;
            t.dataset.jvTitleProcessed = '1';
          }
        });
      });
    } catch (e) {
      console.error('[judgeme-viewmore] title cleanup error', e);
    }

    requestAnimationFrame(function () {
      try {
        var wrapper = item.querySelector('.jdgm-carousel-item__body') || item;
        if (wrapper.querySelector('.jdgm-view-more')) {
          item.dataset.jvProcessed = '1';
          return;
        }

        var btn = document.createElement('span');
        btn.className = 'jdgm-view-more';
        btn.setAttribute('aria-hidden', 'true');
        btn.textContent = 'View more';

        // Append the button immediately; duplicate checks prevent repeats
        try {
          wrapper.appendChild(btn);
        } catch (e) {
          // fallback: insert after wrapper
          try { wrapper.parentNode && wrapper.parentNode.insertBefore(btn, wrapper.nextSibling); } catch (ee) {}
        }

        // mark processed so we don't attempt again
        item.dataset.jvProcessed = '1';
      } catch (err) {
        console.error('[judgeme-viewmore] error adding view-more', err);
      }
    });
  }

  function scan() {
    tried++;
    var items = document.querySelectorAll('.jdgm-carousel-item');
    if (!items || items.length === 0) {
      // Try broader selector if widget uses different root class
      items = document.querySelectorAll('.jdgm-review, .jdgm-carousel__item, .jdgm-card');
    }
    if (!items || items.length === 0) {
      //debug('[judgeme-viewmore] no judge.me items found (attempt ' + tried + ')');
      return;
    }
    //debug('[judgeme-viewmore] found items count=', items.length);
    items.forEach(processItem);
  }

  // Ensure modal customer photos use higher resolution to avoid blurry images
  function adjustModalImages() {
    try {
      var imgs = document.querySelectorAll('.jdgm-full-rev__pic-img');
      imgs.forEach(function (img) {
        try {
          var src = img.getAttribute('data-src') || img.getAttribute('src') || '';
          if (!src) return;
          // Only adjust Judge.me imgix URLs
          if (src.indexOf('judgeme.imgix.net') === -1) return;
          // Prefer w=800 (upgrade from w=160)
          var hi = src;
          if (/([?&])w=\d+/i.test(hi)) {
            hi = hi.replace(/([?&])w=\d+/i, '$1w=800');
          } else if (hi.indexOf('?') !== -1) {
            hi = hi + '&w=800';
          } else {
            hi = hi + '?auto=format&w=800';
          }
          // Apply using setAttribute so other scripts see the change
          img.setAttribute('data-src', hi);
          img.setAttribute('src', hi);
        } catch (e) {}
      });
    } catch (e) {}
  }

    function attachObservers() {
      // Observe for new items added by the Judge.me widget
      var mo = new MutationObserver(function (mutations) {
        var added = mutations.some(function (m) { return m.addedNodes && m.addedNodes.length > 0; });
        if (added) {
          scan();
          try { adjustModalImages(); } catch (e) {}
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });

      // IntersectionObserver: when carousel becomes visible, re-scan items
      try {
        var carouselContainers = document.querySelectorAll('.jdgm-carousel-wrapper, .jdgm-carousel, [class*="jdgm-carousel"]');
        if (carouselContainers.length > 0) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                //debug('[judgeme-viewmore] carousel became visible, re-scanning items');
                setTimeout(function(){ scan(); try { adjustModalImages(); } catch(e){} }, 100);
                setTimeout(function(){ scan(); try { adjustModalImages(); } catch(e){} }, 500);
                setTimeout(function(){ scan(); try { adjustModalImages(); } catch(e){} }, 1000);
              }
            });
          }, { threshold: 0.1 });
          
          carouselContainers.forEach(function (container) {
            io.observe(container);
          });
          //debug('[judgeme-viewmore] IntersectionObserver attached to', carouselContainers.length, 'carousel containers');
        }
      } catch (e) {
        //debug('[judgeme-viewmore] IntersectionObserver setup failed:', e);
      }
    }

    function run() {
      try {
        scan();
        attachObservers();
        
        var retryCount = 0;
        var maxRetries = 12; 
        var retryInterval = setInterval(function () {
          retryCount++;
          try {
            scan();
          } catch (e) {}
          if (retryCount >= maxRetries) {
            clearInterval(retryInterval);
          }
        }, 1000);
      } catch (err) {
        console.error('[judgeme-viewmore] run error', err);
      }
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {

      run();
    } else {
      document.addEventListener('DOMContentLoaded', run);
     
      window.addEventListener('load', run);
    }
  } catch (e) {
    console.error('[judgeme-viewmore] top-level error', e);
  }
})();
